
export const colors = ["#26a69a", "#01579b", "#ec407a", "#ff7043", "#357eb8", "#26c6da", "#7b1fa2", "#ffca28", "#dd2c00"];



/* function that convert a string from UPPER_CASE to camelCase
 * example: WORD_WORD => wordWord
 */
export const toCamelCase = (string) => {
  let out = '';
  for (let x = 0; x < string.length; x += 1) {
    const c = string.charAt(x);
    if (c === '_') {
      out = out.concat(string.charAt(x + 1));
      x += 1;
    } else {
      out = out.concat(c.toLowerCase());
    }
  }
  return out;
};

/* function that convert a string from camelCase to UPPER_CASE
 * example: wordWord => WORD_WORD
 */
export const toUpperCase = (string) => {
  let out = '';
  for (let x = 0; x < string.length; x += 1) {
    const c = string.charAt(x);
    if (c === c.toUpperCase()) out = out.concat('_');
    out = out.concat(c.toUpperCase());
  }
  return out;
};

export const throwError = (message = '') => {
  throw new Error(message);
};

/* validator class
 */
class Validator {
  constructor() {
    this.validators = [
      init => init,
    ];
  }

  // require new validator
  addValidator(func) {
    if (func instanceof Function) {
      this.validators.push(func);
    } else {
      throwError('funtion passed to validator is not a function');
    }
    return this;
  }

  validate(init) {
    return this.validators.reduce((accumulator, validator) => validator(accumulator), init);
  }
}
export const validator = () => new Validator();

/* function that reduce a transformation
 * reduce({ a: 1, b: 2, c: 3 }, ['b']) => { b: 2 }
 */
export const reduce = (obj, params, defaultValue = {}) =>
  params.reduce((accumulator, param) => ({
    ...accumulator,
    [param]: obj[param] || defaultValue,
  }), {});

export const validateAddress = (address, error = 'Address must be valid') => {
  if (address && address.length === 42 && address[0] === '0' && address[1] === 'x') return address;
  throw new Error(error);
};

export const createArray = size => Array(size).fill().map((i, index) => index);




export const jsDateToString = (date) => {
    let output = date.getDate() + "-" +
        (date.getMonth() + 1) + "-" +  //mesi in js hanno index = 0
        date.getFullYear();

    return output;
};

export const jsDateToSQLsmalldatetime = (date) => {
    let output = date.getFullYear() + "-" +
        date.getDate() + "-" +
        (date.getMonth() + 1);  //mesi in js hanno index = 0

    return output;
};



// ritorna la stringa della data in formato yyyy-MM-dd per essere inserita nel db
export const formatDate = (date) => {
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var year = date.getFullYear();

    return year + "-" + month + "-" + day;
}


export const validateEmail = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}